import { useSelector } from "react-redux";
import { UserAuth } from "../types";

export const useAuth = (authSelector: (state: any) => UserAuth) => {
  const {
    upn,
    displayName,
    userType,
    roles,
    org: { id: orgId, name: orgName },
    token,
    experimentalFeatures
  } = useSelector(authSelector);
  return {
    upn,
    displayName,
    userType,
    orgId,
    orgName,
    token,
    isInRole: (...rolesToCheckFor: number[]) =>
      roles.some((role: number) => rolesToCheckFor.includes(role)),
    experimentalFeatures,
  };
};
